// Simple utility for Google Maps API status
let googleMapsLoaded = false;
const loadCallbacks: (() => void)[] = [];

export function markGoogleMapsLoaded() {
  googleMapsLoaded = true;
  loadCallbacks.forEach(cb => cb());
  loadCallbacks.length = 0;
}

export function isGoogleMapsLoaded(): boolean {
  return googleMapsLoaded;
}

export function onGoogleMapsLoad(callback: () => void) {
  if (googleMapsLoaded) {
    callback();
  } else {
    loadCallbacks.push(callback);
  }
}

export function getGoogleMaps() {
  if (typeof window === "undefined") return null;
  return (window as any).google?.maps || null;
}
